import "./style/index.scss";
import { Button } from "antd";
import { useAppSelector } from "../../../../util/hooks";
import { PrinterOutlined } from "@ant-design/icons";
import { useRef } from "react";
import React from "react";
import { currencyBRL } from "../../../../util/dinheiroBRAuxiliar";
import dayjs from "dayjs";
import { useReactToPrint } from "react-to-print";

const ModalVisualizarReciboConsignatario = (props: any) => {
  //estados globais
  const lancamentoConsignatarioState = useAppSelector((state) => state.lancamentoConsignatario);
  const empresaState = useAppSelector((state) => state.empresa);
  const consignatarioState = useAppSelector((state) => state.consignatario);
  const persistedState = useAppSelector((state) => state.persisted);
  const prestacaoContaState = useAppSelector((state) => state.prestacaoConta);

  const empresaSelecionada = empresaState.list.filter((a) => a.id === prestacaoContaState.busca.idEmpresa)[0];
  const lancamentoSelecionado = lancamentoConsignatarioState.entity;
  const consignatario = consignatarioState.entity;

  const relatorio = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({
    content: () => relatorio.current,
  });

  const RelatorioHtml = React.forwardRef<HTMLDivElement>((_props, ref) => {
    return (
      <>
        <div style={{ display: "flex", justifyContent: "right", alignItems: "right", textAlign: "right" }}>
          <Button onClick={handlePrint}>
            <PrinterOutlined style={{ fontSize: "110%" }} /> Imprimir
          </Button>
        </div>
        <div ref={ref} className="relatorio-recibo">
          <strong>{empresaSelecionada.apelido}</strong>
          <br />
          {empresaSelecionada.endereco}, {empresaSelecionada.numero}
          <br />
          {empresaSelecionada.bairro} - {empresaSelecionada.cidade} - {empresaSelecionada.estado}
          <br />
          <br />
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <strong>PAGAMENTO DE DÉBITO - PRODUTO</strong>
            <br />
          </div>
          <div style={{ display: "flex", justifyContent: "right", alignItems: "right", textAlign: "right" }}>
            <strong>{currencyBRL(lancamentoSelecionado.valorTransacao)}</strong>
          </div>
          <hr />
          <strong>No do Recibo:</strong> {lancamentoSelecionado.id}
          <br />
          <strong>Data/Hora...:</strong> {dayjs(lancamentoSelecionado.data).format("DD/MM/YYYY")}
          <br />
          <br />
          <strong>Consignatário:</strong> {consignatario.apelido}
          <br />
          <strong>Extração.....:</strong> Pagamento avulso
          <br />
          <strong>Usuário......:</strong> {persistedState.user.nome}
          <br />
          <strong>Observação...:</strong> {lancamentoSelecionado.historico}
          <br />
          <br />
          <strong>-------- RESUMO DO PAGAMENTO -------</strong>
          <br />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <strong>Total a pagar....:</strong> {currencyBRL(Math.abs(lancamentoSelecionado.saldo - lancamentoSelecionado.valorTransacao))}
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <strong>Total pago.......:</strong> {currencyBRL(lancamentoSelecionado.valorTransacao)}
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <strong>Falta em dinheiro:</strong> {currencyBRL(Math.abs(lancamentoSelecionado.saldo))}
          </div>
          <strong>------------------------------------</strong>
          <br />
          <br />
          {empresaSelecionada.estado}, {dayjs().format("DD/MM/YYYY HH:mm")}
          <br />
          <strong>Mensagem:</strong> {empresaSelecionada.apelido}
          <br />
          <br />
          <br />
          <br />
          <strong>------------------------------------</strong>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <strong>{persistedState.user.nome}</strong>
            <br />
          </div>
        </div>
      </>
    );
  });

  return <RelatorioHtml ref={relatorio} />;
};

export default ModalVisualizarReciboConsignatario;
